// extracted by mini-css-extract-plugin
export default {"privacy_policy":"PrivacyPolicy_privacy_policy__3Tn4U","heading":"PrivacyPolicy_heading__w3p0g","bckbtn":"PrivacyPolicy_bckbtn__Qeu6U"};